import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeResourceUrl',
  standalone: true
})
export class SafeResourceUrlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(url: string | null | undefined): SafeResourceUrl {
    if (!url) {
      return this.sanitizer.bypassSecurityTrustResourceUrl('');
    }

    let embedUrl = url;

    // Handle Facebook Reel & Video links
    if (url.includes('facebook.com') && !url.includes('facebook.com/plugins/video.php')) {
      let targetUrl = url;
      const reelMatch = url.match(/facebook\.com\/reel\/(\d+)/);
      if (reelMatch && reelMatch[1]) {
        // Use canonical watch URL which has broader iframe player compatibility in Facebook plugin
        targetUrl = `https://www.facebook.com/watch/?v=${reelMatch[1]}`;
      }
      embedUrl = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(targetUrl)}&show_text=false&t=0`;
    }
    // Handle YouTube watch links
    else if (url.includes('youtube.com/watch?v=')) {
      const videoId = url.split('v=')[1]?.split('&')[0];
      if (videoId) {
        embedUrl = `https://www.youtube.com/embed/${videoId}`;
      }
    }
    // Handle YouTube short links
    else if (url.includes('youtu.be/')) {
      const videoId = url.split('youtu.be/')[1]?.split('?')[0];
      if (videoId) {
        embedUrl = `https://www.youtube.com/embed/${videoId}`;
      }
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }
}
